import { CreditCard } from "lucide-react";
import { StatsCard } from "./stats/StatsCard";
import { UserManagement } from "./stats/UserManagement";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";

export const StatsManager = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const gymId = profile?.gym_id;
  
  const { data: totalPayments } = useQuery({
    queryKey: ["totalPayments"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("payments")
        .select("amount")
        .gt("paid_at", new Date(new Date().setDate(new Date().getDate() - 30)).toISOString());

      if (error) throw error;
      return data.reduce((acc, curr) => acc + Number(curr.amount), 0);
    },
  });

  const paymentsUrl = gymId ? `/total-pagos?gym_id=${gymId}` : "/total-pagos";

  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-2">
        <UserManagement />
        <div onClick={() => navigate(paymentsUrl)}>
          <StatsCard
            title="Total Pagos"
            value={`$${totalPayments || 0}`}
            description="Click para ver detalles"
            icon={CreditCard}
          />
        </div>
      </div>
    </div>
  );
};